// 顾客的小仓库
const state = {
  goodsId: ''
};
const mutations = {
  updateGoodsId(state, goodsId){
    state.goodsId = goodsId
  }
};
const actions = {};
const getters = {};

export default {state, actions,mutations,getters}